<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadAgentOutboundDetailsReports(1)">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" size="small" @click="exportData">{{ $t('export') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.from" :model="searchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.to" :model="searchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$tc('number')" v-model="searchParams.dst" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$tc('disposition')" v-model="searchParams.disposition" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAgentOutboundDetailsReports(1)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="outboundDetailsDataContainer" :title="$t('outbound_details')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-call-statistics-tab-nav></shared-call-statistics-tab-nav>
      </template>

      <shared-outbound-details-list
        :cdrDatas="cdrDatas"
        :activeColumns="activeColumns"
      ></shared-outbound-details-list>

      <template slot="footer">
        <paginate
          :total="cdrPages"
          :click-handler="loadAgentOutboundDetailsReports"
          :value="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate'
import DatePicker from '@/components/form-inputs/DatePicker'
import AgentOutboundDetailsReport from '@/models/AgentOutboundDetailsReport'
import Pagination from '@/mixins/paginate'
import SharedOutboundDetailsList from '@/views/Shared/OutboundDetails/List'

export default {
  name: 'Window.CallStatistics.OutboundDetails',
  mixins: [Pagination],
  components: {
    DatePicker,
    Paginate,
    SharedOutboundDetailsList
  },
  data () {
    return {
      activeColumns: {},
      cdrDatas: {},
      cdrPages: 1,
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1,
      cdrListCount: 0,
      searchParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : this.$momentHelper.getCurrentDate(),
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : this.$momentHelper.getCurrentDate(),
        service_name: typeof this.$route.query.service_name !== 'undefined' ? this.$route.query.service_name : '',
        dst: typeof this.$route.query.dst !== 'undefined' ? this.$route.query.dst : '',
        disposition: typeof this.$route.query.disposition !== 'undefined' ? this.$route.query.disposition : '',
        apiKey: typeof this.$route.query.apiKey !== 'undefined' ? this.$route.query.apiKey : ''
      },
      companyId: this.$store.getters.userInfo.company.id
    }
  },
  async mounted () {
    this.loadAgentOutboundDetailsReports(this.initialPage)
  },
  methods: {
    async loadAgentOutboundDetailsReports (page) {
      this.$vs.loading({container: '#outboundDetailsDataContainer'})

      this.$router.replace({ query: { ...this.searchParams, page } })
      const response = await AgentOutboundDetailsReport.findAll({ ...this.searchParams, page })
      this.cdrDatas = response.data.data.outboundDetails
      this.cdrPages = response.data.meta.pagination.last_page
      this.activeColumns = response.data.meta.activeColumns

      this.$vs.loading.close('#outboundDetailsDataContainer > .con-vs-loading')
    },
    async exportData () {
      this.$store.dispatch('setIsMainTableLoading', true)
      const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      await AgentOutboundDetailsReport.export({ ...this.searchParams, companyId: this.companyId, language, export: true }) // TODO: Process const response =
      this.$store.dispatch('setIsMainTableLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
